export const   fetechMonth=(dateString )=>{
    console.log("Date fetch ",dateString) 
const date = new Date(dateString);
const monthName = date.toLocaleString('en-US', { month: 'long' });
return monthName;
}